export default __webpack_public_path__ + "static/media/Cyber.861ec77a.svg";